import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'

import store from './state/store'
import i18n from './i18n'
import router from './router/index'
import Vuelidate from 'vuelidate'
import VueApexCharts from 'vue-apexcharts'

import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'
import BootstrapVue from 'bootstrap-vue'
import vco from 'v-click-outside'
import VueSweetalert2 from 'vue-sweetalert2'
import './helpers/axios'
import '@/node-sdk'
import '../src/components/heedesk-components/heedesk-components'
import '../src/router/view/commercial/components/transaction-components/other-transaction-components/tree-table-import'
// import { VueReCaptcha } from 'vue-recaptcha-v3'
import { ColorPicker, ColorPanel } from 'one-colorpicker'
import { initFirebaseBackend } from './authUtils'
import { configureFakeBackend } from './helpers/fake-backend'
import { hidderComponent, getCompanyFromJwtToken } from '@/state/helpers'
import ContentfulVue from 'contentful-vue'
import OtpInput from '@bachdgvn/vue-otp-input'
import VueQRCodeComponent from 'vue-qrcode-component'
import GAuth from 'vue-google-oauth2'
import msal from 'vue-msal'
import VueAppleLogin from 'vue-apple-login'
import VueTelInput from 'vue-tel-input'
import 'vue-tel-input/dist/vue-tel-input.css';
import VueSmartWidget from 'vue-smart-widget'

Vue.use(VueTelInput)

Vue.use(VueAppleLogin, {
  clientId: '686e-2a01-e0a-a64-13b0-8033-8ed3-c61b-515a.eu.ngrok.io',
  scope: 'email name',
  redirectURI: `${process.env.VUE_APP_DNS}login`,
  state: '3333333',
  usePopup: true,
})

Vue.use(GAuth, {
  clientId: '150537086255-nmmdlpj3l467t9ro708801jol4vj2p9r.apps.googleusercontent.com',
  scope: 'profile email  https://www.googleapis.com/auth/calendar',
  prompt: 'select_account',
})

Vue.use(msal, {
  auth: {
    clientId: '373be0c9-c8fc-47ca-936c-3a31d87c37e7',
  },
})

Vue.prototype.$hidderComponent = hidderComponent
Vue.prototype.$getCompanyFromJwtToken = getCompanyFromJwtToken

Vue.use(ColorPanel)
Vue.use(ColorPicker)

Vue.use(VueRouter)
Vue.use(VueSweetalert2)

Vue.component('apexchart', VueApexCharts)
Vue.component('qr-code', VueQRCodeComponent)
Vue.component('v-otp-input', OtpInput)

Vue.use(ContentfulVue, {
  space: 'bxw56tb0jps2',
  accessToken: 'oHEB1awQA-Sx7RAqx6IUoD5DgumZ9KEDzBOkhzSy2gg',
})

const firebaseConfig = {
  apiKey: process.env.VUE_APP_APIKEY,
  authDomain: process.env.VUE_APP_AUTHDOMAIN,
  databaseURL: process.env.VUE_APP_VUE_APP_DATABASEURL,
  projectId: process.env.VUE_APP_PROJECTId,
  storageBucket: process.env.VUE_APP_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
  appId: process.env.VUE_APP_APPId,
  measurementId: process.env.VUE_APP_MEASUREMENTID,
}

Vue.use(VueSmartWidget)

// Vue.use(VueReCaptcha, { siteKey: '6Le47gIeAAAAAMtCBQNPoYwPOiLosNqkI3V6nNcC' })

if (process.env.VUE_APP_ENVIRONMENT !== 'local') {
  Sentry.init({
    Vue,
    dsn: 'https://5edeab2fed5b4ee09e9f49f55b8e02e0@o959982.ingest.sentry.io/5991967',
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ['staging.app.heedesk.io', 'app.heedesk.io', 'www.app.heedesk.io', /^\//],
      }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  })
}
if (process.env.VUE_APP_DEFAULT_AUTH === 'firebase') {
  initFirebaseBackend(firebaseConfig)
} else {
}

configureFakeBackend()

import '@/design/index.scss'

Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(vco)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  fallbackLocale: 'en',
  render: (h) => h(App),
}).$mount('#app')
